module.exports = __webpack_public_path__ + "img/event-view-011.893664de.png";